//#region imports
import React, {useEffect, useState, useRef} from 'react';

// custom components
import {Footer, Text, PageNavigator } from '../../components/atoms';
import { ApiTitle, TabList, TableNumber, RequestHeader, HttpRequest, List } from '../../components/molecules';
import { IntegrationRow } from '../../components/organisms'

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
  
// images
import BookingCard from '../../assets/images/home/booking-card.png';

// swagger
import SwaggerUI from "swagger-ui-react";

// code block
import sample from '../../utils/code/postBookingBody';
import { CopyBlock, dracula} from "react-code-blocks";

// utils
import { Colors } from '../../styles';

// images
import AcknowledgmentExample from '../../assets/images/acknowledgement/acknowledgement-example.png';

//#endregion

// #region tables
const ResponseTable = (props) => {
    return (
        <div>
            <table class="table" style={{ }}>
                <thead style={{}}>
                    <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                        <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col"><Text.TableHeader>Code</Text.TableHeader></th>
                        <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col"><Text.TableHeader>Description</Text.TableHeader></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td scope="col"><Text.TableHeader bold={true}>200 OK</Text.TableHeader></td>
                        <td scope="col"><Text.TableBody>{'Indicates that the bookings the acknowledgement request was successful on the client server. The response describes the state of acknowledgement for each individual booking.'}</Text.TableBody></td>
                    </tr>
                    <tr>
                        <td scope="col"><Text.TableHeader bold={true}>400 Bad Request</Text.TableHeader></td>
                        <td scope="col"><Text.TableBody>Indicates that there was an issue with the form of the acknowledgement.</Text.TableBody></td>
                    </tr>
                    <tr>
                        <td scope="col"><Text.TableHeader bold={true}>403 Unauthorized Access</Text.TableHeader></td>
                        <td scope="col"><Text.TableBody>{'Indicates that the request is unauthorized. Typically the result of not including the Authorization header in the request.'}</Text.TableBody></td>
                    </tr>
                    <tr>
                        <td scope="col"><Text.TableHeader bold={true}>500 Internal Server Error</Text.TableHeader></td>
                        <td scope="col"><Text.TableBody>{'Indicates that there was an internal error while receiving the response.'}</Text.TableBody></td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
//#endregion

const Acknowledgement = (props) => {

    // control tab
    const [tab, setTab] = useState(1)

    const border = false; 
    const ssrRef = useRef(null)
    const executeScroll = () => ssrRef.current.scrollIntoView()    

    useEffect(() => {

    }, []);

    const [STATE, SETSTATE] = useState(false)

    return (
        <>
            {/* Title and Prerequisities */}
            <Row className='mt-5'>
                <Col>
                    <ApiTitle 
                        smallTitle={'POST Request'}
                        title={'Creating an Acknowledgement'}
                        subtitle={'Use this guide to learn how acknowledgements work and how to send them to the PRM Connect API.'}
                        prerequisites={[
                            'JSON Web Token',
                        ]}
                    />
                </Col>
            </Row>

            {/* Overview Authentication */}
            <Row>
                <Col >
                            
                    {/* Overview */}
                    <Text.Subheading>Overview</Text.Subheading>
                    <Text.Text>{`An acknowledgement is used to let PRM Connect know that the booking(s) have been sucessfully received and saved.
                    Acknowledements are important because it allows Connect to only send the booking once, reducing the data shared between the client.`}</Text.Text>
                    <img
                        src={AcknowledgmentExample}
                        width='950px'
                        alt=""
                    />
                </Col>
            </Row>

            {/* Section Tab Selector */}
            <Col >
                <TabList 
                    tabs={['Overview', 'Examples', 'Implementation',]}
                    setTab={(value)=>{ setTab(value)}}
                />
            </Col>

            {/* Overview 1. Authorization */}
            { tab ==  1 &&
            <>
            <Row className='mt-4' style={{borderWidth:border && 1, borderStyle: border && 'solid' }}>
                <Col >
                    <Container>
                        <Text.Subheading>1. Authorization</Text.Subheading>
                        <Text.Text>{'Authentication is achieved by means of a JSON Web Token, generated from a Client ID and Client Secret and using the authentication endpoint discussed in the Authentication Section'}</Text.Text>
                    </Container>
                </Col>
            </Row>

            {/* 2. Request */}
            <Row className='mt-4' style={{borderWidth:border && 1, borderStyle: border && 'solid' }}>
                <Col >
                    <Container>
                        <Text.Subheading>2. Request</Text.Subheading>
                        <Text.Text>{'This section describes the Acknowledgement with a detailed API structure,  an example request and response, JSON schemas for request, responses and error response codes.'}</Text.Text>
                    </Container>
                </Col>
            </Row>


            {/* Overview 3.1 - Header Table */}
            <Row className='mt-2'>
                <Col >
                    <Container>
                        <Text.Subheading>2.1 Header</Text.Subheading>
                        <Text.Text>{'The request contains the following headers:'}</Text.Text>
                        <RequestHeader contentType={true} />
                    </Container>
                </Col>
            </Row>

            <Row className='mt-2'>
                <Col >
                    <Container>
                        <Text.Subheading>2.2 Body</Text.Subheading>
                        <Text.Text>{'The request body contains a list of arbitrary length, containing objects with the id and revision number fields to identify the bookings that are being acknowledged along with the revision number being saved.'}</Text.Text>
                            <p>Request Body</p>
                            {/* <CopyBlock
                                language={'json'}
                                text={sample['acknowledgementBody']}
                                showLineNumbers={false}
                                theme={dracula}
                                wrapLines={false}
                            /> */}
                    </Container>
                </Col>
            </Row>


            {/* Overview 3.2 - Response */}
            <Row className='mt-2'>
                <Col >
                    <Container>
                        <Text.Subheading>2.3 Response</Text.Subheading>
                        <Text.Text>{'This section reviews the different responses and their meaning.'}</Text.Text>
                        <ResponseTable />
                    </Container>
                </Col>
            </Row>
            </>
            }

            {/* Example */}
            { tab === 2 && 
            <>
                <Row className='mt-4'>
                    <Col >
                        <Container>

                            {/* Text */}
                            <Text.Subheading>1. Example Request</Text.Subheading>
                            <Text.Text>{'This section contains examples of posting an acknowledgement'}</Text.Text>

                            <Text.Subsubheading>1.1 Posting an acknowledgement</Text.Subsubheading>
                            <Text.Text>{'In this example we post a single acknowledgement for a multiple bookings received, to be marked as saved by the client, making sure that they are not sent again.'}</Text.Text>
                            <Text.Subsubheading>1.1.1 Request</Text.Subsubheading>
                            <HttpRequest 
                                requestType={'POST'}
                                url={'https://connect.prmassist.com/api/v1/bookings/acknowledge'}
                                headers={['Authorization: Bearer <token>', 'Content-Type: [application/json]']}
                            />
                            <Col>
                                <p>Request Body</p>
                                <CopyBlock
                                    language={'json'}
                                    text={sample['acknowledgementBody']}
                                    showLineNumbers={false}
                                    theme={dracula}
                                    wrapLines={false}
                                />
                            </Col>

                        </Container>
                    </Col>
                </Row>

                {/* Example Response */}
                <Row className='mt-5'>
                    <Col >
                        <Container>
                            
                            {/* Text */}
                            <Text.Subsubheading>1.1.2 Response</Text.Subsubheading>
                            <Text.Text>The response is a list of key value pairs, where the key is the acknowledged bookings unique identifier, followed by a textual description of whether or not the booking was successfully acknowledged.</Text.Text>
                            
                            {/* Code block */}
                            <Row>
                                <Col>
                                    <p>Response from Request</p>
                                    <CopyBlock
                                        language={'json'}
                                        text={sample['acknowledgementResponse']}
                                        showLineNumbers={false}
                                        theme={dracula}
                                        wrapLines={false}
                                    />
                                </Col>
                            </Row>

                        </Container>
                    </Col>
                </Row>
                
            </>
            }

            {/* Request */}
            { tab === 3 &&
            <>
                <Row className='mt-4'>
                    <Col>
                        <Container>
                            <Text.Subheading>1. Swagger Implementation</Text.Subheading>
                            <Text.Text>{'This section contains a swagger that can be used for posting an example booking, reviewing the different responses and error codes'}</Text.Text>
                            <SwaggerUI url="acknowledge.yaml" />
                        </Container>
                    </Col>
                </Row>
            </>
            }

            {/* Page Navigator */}
            <Row>
                <Col>
                    <Container>
                        <PageNavigator leftText={'Polling Bookings'} leftLink={'/getting-updated-deleted'} rightText={'Update Bookings'} rightLink={'/update-bookings'} />
                    </Container>
                </Col>
            </Row>
            
            <Footer small={true} />            
        </>
    );
};

export default Acknowledgement;
